import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import CollapseAllIcon from "@entrilia/shared/icons/CollapseAllIcon";
import ExpandAllIcon from "@entrilia/shared/icons/ExpandAllIcon";
import MemberChangeRow from "./MemberChangeRow";
import type { MemberChangeView } from "./membersChangeRequestHelper";

interface Props {
  members: MemberChangeView[];
  getContactHref?: (member: MemberChangeView) => string | undefined;
  isPending: boolean;
}

const MemberChangesTable = ({ members, getContactHref, isPending }: Props) => {
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);

  const allExpanded = members.every((member) => expandedKeys.includes(member.key));

  const handleToggleAllClick = () => {
    setExpandedKeys(allExpanded ? [] : members.map((member) => member.key));
  };

  const handleToggle = (memberKey: string) => {
    setExpandedKeys((keys) =>
      keys.includes(memberKey) ? keys.filter((key) => key !== memberKey) : [...keys, memberKey]
    );
  };

  return (
    <RoundedTable withoutColumnBorders>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: 48, px: 0.75 }}>
            <ExpandCollapseButton
              expanded={allExpanded}
              onToggle={handleToggleAllClick}
              ExpandIcon={ExpandAllIcon}
              CollapseIcon={CollapseAllIcon}
              sx={{ my: -1 }}
              aria-label="Toggle all contact details"
            />
          </TableCell>
          <TableCell>Name</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {members.map((member) => (
          <MemberChangeRow
            key={member.key}
            member={member}
            expanded={expandedKeys.includes(member.key)}
            onToggleExpanded={() => handleToggle(member.key)}
            contactHref={getContactHref?.(member)}
            isPending={isPending}
          />
        ))}
      </TableBody>
    </RoundedTable>
  );
};

export default MemberChangesTable;
